import { useCenterLayerStore } from '@/shared/stores/centerLayer.store';
import { useCallback } from 'react';

/**
 * Hook Facade para interactuar con el store de centerLayer
 * Siguiendo el mismo patrón que useAppStudents
 * Proporciona una API estable y segura para evitar bucles infinitos
 */
export const useAppCenterLayer = () => {
  // 1. Selecciona cada pieza del estado de forma individual
  const apiData = useCenterLayerStore((state) => state.apiData);
  const specificFilters = useCenterLayerStore((state) => state.specificFilters);
  const careerFilter = useCenterLayerStore((state) => state.careerFilter);
  const isLoading = useCenterLayerStore((state) => state.isLoading);

  // 2. Selecciona las acciones del store
  const loadData = useCenterLayerStore((state) => state.loadData);
  const setSpecificFilters = useCenterLayerStore(
    (state) => state.setSpecificFilters,
  );
  const setCareerFilter = useCenterLayerStore((state) => state.setCareerFilter);
  const setLoading = useCenterLayerStore((state) => state.setLoading);
  const clearData = useCenterLayerStore((state) => state.clearData);

  // 3. Memoiza las funciones para mantener referencias estables
  const handleSetSpecificFilters = useCallback(
    (filters: Parameters<typeof setSpecificFilters>[0]) => {
      setSpecificFilters(filters);
    },
    [setSpecificFilters],
  );

  const handleSetCareerFilter = useCallback(
    (filter: Parameters<typeof setCareerFilter>[0]) => {
      setCareerFilter(filter);
    },
    [setCareerFilter],
  );

  const handleSetLoading = useCallback(
    (loading: boolean) => {
      setLoading(loading);
    },
    [setLoading],
  );

  const handleClearData = useCallback(() => {
    clearData();
  }, [clearData]);

  // 4. API pública limpia
  return {
    // Estado
    apiData,
    specificFilters,
    careerFilter,
    isLoading,

    // Acciones estables
    loadData, // Esta es estable en Zustand
    setSpecificFilters: handleSetSpecificFilters,
    setCareerFilter: handleSetCareerFilter,
    setLoading: handleSetLoading,
    clearData: handleClearData,
  };
};
